module.exports = __webpack_public_path__ + "static/media/Header_eye.8b56e61e.png";